import { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ConnectorsList from "../Connectors/ConnectorsList";

const ModalConnectors = ({ clientId, clientName }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  return (
    <>
      <Button color="primary" size="sm" onClick={toggleModal}>
        <i className="fas fa-plug me-1" /> Conectores
      </Button>

      <Modal isOpen={modalOpen} toggle={toggleModal} size="xl">
        <ModalHeader toggle={toggleModal}>Cliente - {clientName}</ModalHeader>
        <ModalBody>
          <ConnectorsList clientId={clientId} clientName={clientName} />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>
            Fechar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ModalConnectors;
